import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

/* Capa del Avatar y Foto perfil */
export const StyledBoxPerfil = styled.div`
  position: relative;

  .avatar-edit {
    position: absolute;
    top: ${rem('9px')};
    right: ${rem('3px')};
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    width: ${rem('25px')};
    height: ${rem('25px')};
    padding: ${rem('2px')};
    transition: 0.5s;

    & > svg {
      margin: 0;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 1);
    }

    ${mediaqueries.greaterThan('tablet')`
      top: ${rem('10px')};
    right: ${rem('10px')};
    width: ${rem('34px')};
    height: ${rem('34px')};
    padding: 0;
  `};
  }
`;

/* Capa contenedora interior */
export const StyledBoxinterior = styled.div`
  position: relative;
`;

/* Avatar svg */
export const StyledAvatar = styled(Icon)`
  width: 100%;
  display: block;
`;

/* Contenedora foto */
export const StyledBoxAvatar = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 9%;
  left: 25.45%;
  width: 47.458%;
  height: 50.909676035%;
  ${props => {
    switch (props.type) {
      case 'quarter':
        return {
          top: '25%'
        };
      case 'axis1':
        return {
          top: '9.5%'
        };
      case 'axis2':
        return {
          top: '14.55%'
        };
      case 'axis3':
        return {
          top: '37.8%'
        };
      case 'linkedin':
        return 'top: 9.7%';
      default:
        return 'top: 37%';
    }
  }};
`;

/* Iniciales usuario por defecto */
export const StyledName = styled.span`
  color: ${props => props.theme.fonts.grayDark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('24px')};
  text-transform: uppercase;

  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('36px')};
  `};
`;

/* Foto Usuario */
export const StyledUser = styled.img`
  width: 100%;
  border-radius: 50%;
`;
